<template>
    <div class="m-5 md:m-15 2xl:m-20" @keydown="progressbar.userKeyDown()" @keyup="progressbar.userKeyUp()" @click="calculate_progress">

        <h3 class="mb-5 md:mb-15 2xl:mb-20">Autonomie</h3>

        <div class="grid grid-cols-12 gap-x-4 gap-y-10">

        <!-- DEBUT Temps de travail -->
        <div class="col-span-full text-base text-indigo-600">TEMPS DE TRAVAIL</div>
            <input-select
                name="temps_travail"
                libelle="Temps de travail"
                :necessary="true"
                :value="form.temps_travail" @input="(newValue) => {form.temps_travail = newValue;}"
                :datas="[
                    { value: 'Temps plein' },
                    { value: 'Temps partiel' },
                ]"
                class="md:col-span-6"
            />
            <input-text
                name="temps_travail_precis"
                libelle="Précisez"
                :necessary="false"
                :value="form.temps_travail_precis" @input="(newValue) => {form.temps_travail_precis = newValue;}"
                class="md:col-span-6"
            />
            <!-- END Temps de travail -->

            <!-- DEBUT Transport -->
            <div class="col-span-full text-base text-indigo-600  mt-10">TRANSPORT</div>

            <input-select
                name="type_transport"
                libelle="Type de transport principal"
                :necessary="true"
                :value="form.type_transport" @input="(newValue) => {form.type_transport = newValue;}"
                :datas="[
                    { value: 'Bus' },
                    { value: 'Tram' },
                    { value: 'Voiture'},
                    { value: 'Vélo'},
                    { value: 'Train'},
                    { value: 'Scooter/Moto'},
                ]"
                class="md:col-span-4"
            />
            <input-select
                name="accompagnateur_transport"
                libelle="Accompagnateur"
                :necessary="true"
                :value="form.accompagnateur_transport" @input="(newValue) => {form.accompagnateur_transport = newValue;}"
                :datas="[
                    { value: 'Oui' },
                    { value: 'Non' },
                ]"
                class="md:col-span-4"
            />
            <input-select
                name="reperage_transport"
                libelle="Repérage"
                :necessary="true"
                :value="form.reperage_transport" @input="(newValue) => {form.reperage_transport = newValue;}"
                :datas="[
                    { value: 'Oui' },
                    { value: 'Non' },
                ]"
                class="md:col-span-4"
            />
            <input-select
                name="place_stationnement_adaptee"
                libelle="Place de stationnement adaptée"
                :necessary="true"
                :value="form.place_stationnement_adaptee" @input="(newValue) => {form.place_stationnement_adaptee = newValue;}"
                :datas="[
                    { value: 'Oui' },
                    { value: 'Non' },
                ]"
                class="md:col-span-4"
            />
            <input-text
                name="distance_max"
                libelle="Précisez la distance max du lieu de stage/travail"
                :necessary="true"
                :value="form.distance_max" @input="(newValue) => {form.distance_max = newValue;}"
                class="md:col-span-4"
            />
            <input-select
                name="permis"
                libelle="Permis de conduire"
                :necessary="true"
                :value="form.permis" @input="(newValue) => {form.permis = newValue;}"
                :datas="[
                    { value: 'Oui' },
                    { value: 'Non' },
                ]"
                class="md:col-span-4"
            />
            <input-text-area
                name="transport_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.transport_comment" @input="(newValue) => {form.transport_comment = newValue;}"
                class="md:col-span-full"
            />

            <div class="col-span-full text-base text-indigo-600  mt-10">RESTAURATION</div>
            <input-select
                name="aides_restauration"
                libelle="Aides"
                :necessary="true"
                :value="form.aides_restauration" @input="(newValue) => {form.aides_restauration = newValue;}"
                :datas="[
                    { value: 'Aucune aide' },
                    { value: 'Aide humaine' },
                    { value: 'Aide technique'},
                    { value: 'Autre'},
                ]"
                class="md:col-span-6"
            />
                <transition
                    enter-active-class="ease-in duration-300"
                    enter-class="opacity-0"
                    leave-active-class="ease-out duration-300"
                    leave-to-class="opacity-0"
                >
                    <input-text
                        v-if="form.aides_restauration == 'Autre'"
                        name="aides_restauration_precis"
                        libelle="Précisez (si autre)"
                        :necessary="true"
                        :value="form.aides_restauration_precis" @input="(newValue) => {form.aides_restauration_precis = newValue;}"
                        class="md:col-span-6"
                    />
                </transition>
            <input-text-area
                name="aide_restauration_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.aide_restauration_comment" @input="(newValue) => {form.aide_restauration_comment = newValue;}"
                class="md:col-span-full"
            />

            <!-- DEBUT Consignes -->
            <div class="col-span-full text-base text-indigo-600  mt-10">CONSIGNES</div>
            <input-select
                name="consignes"
                libelle="Consignes"
                :necessary="true"
                :value="form.consignes" @input="(newValue) => {form.consignes = newValue;}"
                :datas="[
                    { value: 'Orales' },
                    { value: 'Ecrites' },
                    { value: 'Donnez des consignes une par une'},
                    { value: 'Besoin d\'un rappel de consigne'},
                ]"
                class="md:col-span-6"
            />
            <input-text
                name="consignes_precis"
                libelle="Précisez (dictaphone, support visuel, prise de note)"
                :necessary="false"
                :value="form.consignes_precis" @input="(newValue) => {form.consignes_precis = newValue;}"
                class="md:col-span-6"
            />
            <input-text-area
                name="consignes_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.consignes_comment" @input="(newValue) => {form.consignes_comment = newValue;}"
                class="md:col-span-full"
            />
            <!-- END Consignes -->

            <!-- DEBUT Communications -->
            <div class="col-span-full text-base text-indigo-600  mt-10">COMMUNICATION</div>
            <input-select
                name="communication"
                libelle="Communication"
                :necessary="true"
                :value="form.communication" @input="(newValue) => {form.communication = newValue;}"
                :datas="[
                    { value: 'Bonne élocution en face à face' },
                    { value: 'Bonne élocution dans un groupe' },
                    { value: 'Elocution difficile mais compense à l\'écrit'},
                    { value: 'Communication difficile à l\'écrit comme l\'oral'},
                    { value: 'Communication par gestes'},
                ]"
                class="md:col-span-6"
            />
            <input-text-area
                name="communication_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.communication_comment" @input="(newValue) => {form.communication_comment = newValue;}"
                class="md:col-span-full"
            />
            <!-- END Communications -->

            <!-- DEBUT ECRITURE -->
            <div class="col-span-full text-base text-indigo-600  mt-10">ECRITURE</div>
            <input-select
                name="ecriture"
                libelle="Ecriture"
                :necessary="true"
                :value="form.ecriture" @input="(newValue) => {form.ecriture = newValue;}"
                :datas="[
                    { value: 'Manuscrite' },
                    { value: 'Dactylographiée' },
                    { value: 'Synthèse vocale'},
                    { value: 'Limiter la quantité d\'écrits à produire'},
                    { value: 'Communication par gestes'},
                ]"
                class="md:col-span-6"
            />
            <input-text-area
                name="ecriture_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.ecriture_comment" @input="(newValue) => {form.ecriture_comment = newValue;}"
                class="md:col-span-full"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import CheckboxGreen from '../../../components/Inputs/CheckboxGreen';
import CheckboxForm from '../../../components/Inputs/CheckboxForm';
import Icon from '../../../components/Icon';

export default {
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxGreen,
    CheckboxForm,
    Icon
  },
  props:['progressbar'],

  name: 'Autonomie',

  data() {
    return {
      // Initial state of the form
      form:{
        temps_travail:'',
        temps_travail_precis:'',
        type_transport:'',
        accompagnateur_transport:'',
        reperage_transport:'',
        place_stationnement_adaptee:'',
        distance_max:'',
        permis: '',
        transport_comment:'',
        aides_restauration:'',
        aides_restauration_precis:'',
        aide_restauration_comment:'',
        consignes:'',
        consignes_precis:'',
        consignes_comment:'',
        communication:'',
        communication_comment:'',
        ecriture:'',
        ecriture_comment:'',
      }
    };
  },

  async mounted(){
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)
    this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },

  methods: {
    ...mapMutations({
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
    }),
  },
  computed:{
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
    }),

    initForm(){
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);
    },
  },
  watch:{
    form: {
      handler(){
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true
    }
  }
};
</script>
